import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { fetchSimilarListings } from "@/api/fetchSimilarListings";
import { SimilarListingsCarousel } from "@/components/SimilarListings/SimilarListingsCarousel";
import { useSimilarListings } from "@/components/SimilarListings/useSimilarListings";
import { SIMILAR_LISTING_PATH } from "@/constants/api";
import { useClassifiedId } from "@/contexts/classified";
import { useBrandUrl } from "@/hooks";
import { Box } from "@gemini/core";
import { useEffect } from "react";
import { useSellerLeadLink } from "../Sections/SellerLeadTeaser";
export const ConfirmPageSimilarListings = () => {
    const { similarListings, similarRecords, isDisplayed, isFetched, setSimilarListingsData, } = useSimilarListings();
    const classifiedId = useClassifiedId();
    const similarListingsUrl = useBrandUrl({
        // @ts-ignore
        endpoint: SIMILAR_LISTING_PATH(classifiedId),
    });
    const { funnel: funnelUrl } = useSellerLeadLink();
    useEffect(() => {
        if (!isFetched && !isDisplayed && classifiedId) {
            fetchSimilarListings(similarListingsUrl).then((data) => {
                setSimilarListingsData(data);
            });
        }
    }, [
        isFetched,
        isDisplayed,
        similarListingsUrl,
        setSimilarListingsData,
        classifiedId,
    ]);
    if (!isDisplayed || similarListings.length === 0) {
        return null;
    }
    return (_jsxs(Box, { width: "100%", minHeight: "520px", paddingTop: {
            "breakpoint.base": "spacing.none",
            "breakpoint.lg": "spacing.24",
        }, paddingLeft: {
            "breakpoint.base": "spacing.24",
        }, borderRadius: {
            "breakpoint.base": "unset",
            "breakpoint.lg": "radius.16",
        }, backgroundColor: {
            "breakpoint.base": "unset",
            "breakpoint.lg": "color.background.light",
        }, children: [funnelUrl && (_jsx(Box, { paddingHorizontal: {
                    "breakpoint.base": "spacing.16",
                    "breakpoint.sm": "spacing.32",
                    "breakpoint.lg": "spacing.none",
                }, gridColumn: {
                    "breakpoint.base": "col-start / span 4",
                    "breakpoint.md": "col-start / span 4",
                    "breakpoint.lg": "col-start / span 12",
                    "breakpoint.sm": "col-start / span 8",
                    "breakpoint.xl": "col-start 1 / span 12",
                    "breakpoint.xxl": "col-start 2 / span 10",
                } })), _jsx(Box, { as: "section", id: "similarListings", gridColumn: {
                    "breakpoint.base": "col-start / span 4",
                    "breakpoint.md": "col-start / span 4",
                    "breakpoint.lg": "col-start / span 12",
                    "breakpoint.sm": "col-start / span 8",
                    "breakpoint.xl": "col-start 1 / span 12",
                    "breakpoint.xxl": "col-start 2 / span 10",
                }, marginBottom: {
                    "breakpoint.lg": "spacing.16",
                }, overflow: "clip", position: "relative", unsafe_className: "HideOnPrint", paddingLeft: {
                    "breakpoint.base": "spacing.16",
                    "breakpoint.sm": "spacing.32",
                    "breakpoint.lg": "spacing.none",
                }, children: _jsx(SimilarListingsCarousel, { similarListings: similarListings, similars: similarRecords, display: isDisplayed }) })] }));
};
